function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2FAFF",
  fillOpacity: 0.9,
  d: "M16 16.6667V7.33333C16 6.6 15.4 6 14.6667 6H5.33333C4.6 6 4 6.6 4 7.33333V16.6667C4 17.4 4.6 18 5.33333 18H14.6667C15.4 18 16 17.4 16 16.6667ZM6.9029 13.982C7.29516 13.4777 8.0533 13.4655 8.46152 13.957L8.53761 14.0486C8.94611 14.5405 9.7049 14.5279 10.0969 14.0228L10.8631 13.0355C11.2676 12.5142 12.0572 12.5207 12.4531 13.0486L13.4667 14.4C13.9611 15.0592 13.4907 16 12.6667 16H7.37797C6.54582 16 6.07773 15.0429 6.58862 14.3861L6.9029 13.982Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2FAFF",
  fillOpacity: 0.9,
  fillRule: "evenodd",
  d: "M28 21C28 21.5523 27.5523 22 27 22H5C4.44772 22 4 21.5523 4 21C4 20.4477 4.44772 20 5 20H27C27.5523 20 28 20.4477 28 21Z",
  clipRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2FAFF",
  fillOpacity: 0.9,
  fillRule: "evenodd",
  d: "M28 25C28 25.5523 27.5523 26 27 26H5C4.44772 26 4 25.5523 4 25C4 24.4477 4.44772 24 5 24H27C27.5523 24 28 24.4477 28 25Z",
  clipRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2FAFF",
  fillOpacity: 0.9,
  fillRule: "evenodd",
  d: "M28 8C28 8.55228 27.5523 9 27 9H20C19.4477 9 19 8.55228 19 8C19 7.44772 19.4477 7 20 7H27C27.5523 7 28 7.44772 28 8Z",
  clipRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2FAFF",
  fillOpacity: 0.9,
  fillRule: "evenodd",
  d: "M28 12C28 12.5523 27.5523 13 27 13H20C19.4477 13 19 12.5523 19 12C19 11.4477 19.4477 11 20 11H27C27.5523 11 28 11.4477 28 12Z",
  clipRule: "evenodd"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2FAFF",
  fillOpacity: 0.9,
  fillRule: "evenodd",
  d: "M28 16C28 16.5523 27.5523 17 27 17H20C19.4477 17 19 16.5523 19 16C19 15.4477 19.4477 15 20 15H27C27.5523 15 28 15.4477 28 16Z",
  clipRule: "evenodd"
});

function SvgRichText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRichText);
export default __webpack_public_path__ + "static/media/rich-text.6940d296.svg";
export { ForwardRef as ReactComponent };